import React from 'react';
import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  const scrollToOffer = () => {
    document.getElementById('final-cta')?.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  };
  return <section className="relative min-h-screen flex flex-col items-center justify-center pt-20 pb-12 px-4 overflow-hidden" data-id="element-89">
      {/* Background Image with Overlays */}
      <div className="absolute inset-0 z-0" data-id="element-90">
        <img src="https://cdn.magicpatterns.com/uploads/7SsijiU9XC1do1amvfmQd9/hoQY8NtidsdPdXCJ5E83Z.png" alt="Camino hacia la luz celestial" className="w-full h-full object-cover object-center" data-id="element-91" />
        <div className="absolute inset-0 bg-gradient-to-b from-cream-50/50 via-cream-50/30 to-cream-50" data-id="element-92" />
        <div className="absolute inset-0 bg-radial-gradient from-terra-500/10 to-transparent opacity-50 mix-blend-overlay" data-id="element-93" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto text-center flex flex-col items-center mt-12" data-id="element-94">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="text-4xl md:text-6xl lg:text-7xl font-bold mb-6 leading-tight text-brown-900 text-glow-gold" data-id="element-95">
          ¿Y si el éxito que buscas no depende de tu esfuerzo, sino de tu{' '}
          <span className="text-terra-500 italic" data-id="element-96">alineación</span>?
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="text-xl md:text-2xl text-brown-900 font-heading mb-8 max-w-3xl" data-id="element-97">
          Descubre las 5 Reglas de Dios para Triunfar que el mundo de los
          negocios olvidó contarte.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="w-24 h-px bg-gradient-to-r from-transparent via-terra-500 to-transparent mb-8" data-id="element-98" />

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.8
      }} className="text-lg md:text-xl text-brown-900 font-body mb-12 max-w-2xl leading-relaxed" data-id="element-99">
          El sistema de pioneros como Brian Tracy enfocado a emprendedores y
          líderes que quieren resultados exponenciales...{' '}
          <span className="text-terra-500 font-semibold" data-id="element-100">
            sin perder su paz, su familia ni su fe en el proceso.
          </span>
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 1
      }} data-id="element-101">
          <CTAButton onClick={scrollToOffer} className="text-lg px-10 py-5" data-id="element-102">
            QUIERO LAS 5 REGLAS AHORA
            <ChevronDown className="w-5 h-5 -rotate-90" data-id="element-103" />
          </CTAButton>
        </motion.div>
      </div>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.5,
      duration: 1
    }} className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10" data-id="element-104">
        <motion.div animate={{
        y: [0, 10, 0]
      }} transition={{
        repeat: Infinity,
        duration: 2
      }} data-id="element-105">
          <ChevronDown className="w-8 h-8 text-terra-500/50" data-id="element-106" />
        </motion.div>
      </motion.div>
    </section>;
}